import addOn from './addon.json';
import benefits from './benefits.json';
import errors from './errors.json';
import faq from './faq.json';
import form from './form.json';
import page from './page.json';
import plan from './plan.json';
import quotation from './quotation.json';
import review from './review.json';
import application from "./application.json";

export const en_MY = {
    translation: {
        ...page,
        ...form,
        ...addOn,
        ...benefits,
        ...plan,
        ...faq,
        ...addOn,
        ...quotation,
        ...errors,
        ...review,
    },
    application,
}